export const OOPS_SOMETHING_WENT_WRONG = "Oops Something went wrong!";

export const EMPTY_NATIVE_CART_DATA = "Received empty cart data from native";

export const RETRY = "Retry";

export const GO_BACK = "Go Back";

export const HTTP_STATUS_CODES = {
    TOO_MANY_REQUESTS: 429,
};

export const ERROR_STATUS_CODES = {
    GENERIC_FAILURE: 150,
    SESSION_EXPIRED: 999,
    DEAL_ALREADY_BOOKED: 104,
    DAILY_OUTLET_BOOKING_LIMIT_EXCEEDED: 105,
    DAILY_OVERALL_BOOKING_LIMIT_EXCEEDED: 106,
    QR_INVALID: 191,
    API_FAILURE: 1,
    EVENT_BOOKING_SEAT_LIMIT_EXCEEDED: 152,
};

export const CUSTOM_ERROR_PAYLOAD = {
    IMAGE: "CartPageAssets/empty_cart",
    TITLE: "Oops!",
    MESSAGE: "Oops!",
    ACTION: "Retry!",
};

export const ERROR_IMAGE_MAX_DIMENSIONS = {
    WIDTH: 500,
    HEIGHT: 500,
};

export const EMPTY_TABLE_RESERVATION_CART_TEXTS = {
    IMAGE: "CartPageAssets/empty_cart",
    TITLE: "Empty Cart",
    MESSAGE: "Your cart is empty. Go back and edit details",
    ACTION: "Browse Restaurants",
    POP_GO_TO_HOME_ACTION: "Go to home",
};

export const CUSTOM_HANDLING_ERRORCODES = [
    ERROR_STATUS_CODES.DEAL_ALREADY_BOOKED,
    ERROR_STATUS_CODES.DAILY_OUTLET_BOOKING_LIMIT_EXCEEDED,
    ERROR_STATUS_CODES.DAILY_OVERALL_BOOKING_LIMIT_EXCEEDED,
    ERROR_STATUS_CODES.GENERIC_FAILURE,
    ERROR_STATUS_CODES.EVENT_BOOKING_SEAT_LIMIT_EXCEEDED,
];

export const GENERIC_HANDLING_ERRORCODES = [ERROR_STATUS_CODES.API_FAILURE, ERROR_STATUS_CODES.SESSION_EXPIRED];

export const REMOVE_SOLD_OUT_ITEMS = "Remove Sold Out Items";
export const PROCEED = "Proceed";
export const CLIENT_ID = "portal";
